import React, { useContext } from "react";
import { MyContext } from "../MyProvider";
import { scAxiosAdmin } from "../..";
import ReactHtmlParser from "react-html-parser";
import BookTestPopUp from "./BooTestPopUp";

const CartPopUp = () => {
  const { state, removeFromCart, removeItemFromCart } = useContext(MyContext);
  const cartData = JSON.parse(localStorage.getItem("cart"));
  const totalAmount = JSON.parse(localStorage.getItem("totalAmount"));
  const totalQuantity = JSON.parse(localStorage.getItem("totalQuantity"));
  const handleSubmit = async () => {
    let date = new Date();
    var formattedDate =
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2);

    let patient_id = localStorage.getItem("USER_ID");
    let qty = totalQuantity;
    let currency = "BDT";
    let type = "all";
    let total = totalAmount;
    let grand_total = totalAmount;
    let customer_data = {
      customer_name: localStorage.getItem("patient_name"),
      phone_number: localStorage.getItem("login_phone_number"),
    };
    let additional = cartData;
    let payment_type = "sslCommerz";
    let sslCommerz_urls = {
      success_url: `${window.location.origin}/success-order`,
      fail_url: `${window.location.origin}/fail`,
      cancel_url: `${window.location.origin}/cancel`,
    };
    let status = 1;

    // console.log("your log output", window);

    const postData = {
      date: formattedDate,
      patient_id,
      qty,
      total,
      type,
      currency,
      grand_total,
      customer_data,
      additional,
      payment_type,
      sslCommerz_urls,
      status,
    };

    try {
      const response = scAxiosAdmin
        .post("ledger", postData, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": `application/json`,
          },
        })
        .then((response) => {
          if (response.data.status === "success") {
            window.location.href = response.data.data;
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  return (
    <div
      class="offcanvas offcanvas-end"
      tabindex="-1"
      id="cartOffcanvasRight"
      aria-labelledby="cartOffcanvasRightLabel"
      style={{ minWidth: "30%", zIndex: 99999999999 }}
    >
      <div
        class="offcanvas-header"
        style={{ paddingRight: "2rem", paddingLeft: "2rem" }}
      >
        <div className="" style={{ paddingTop: "3rem" }}>
          <h4 style={{ color: "#af9763" }}>Cart Items</h4>
        </div>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body pb-5">
        <div class="row gy-4 left-offcanvas">
          {cartData ? (
            cartData.length > 0 ? (
              cartData.map((cart, index) => (
                <div key={index} className="col-sm-12">
                  <div
                    className="card shadow-md  bg-body"
                    style={{
                      borderLeft: "10px solid #55A5A6",
                      borderRadius: "10px",
                    }}
                  >
                    <div className="card-body d-flex justify-content-between align-items-start">
                      <div
                        className=""
                        style={{ width: "80%", maxWidth: "1019px" }}
                      >
                        {cart.type === "investigation" ? (
                          <div>
                            <p>Type : Investigation</p>
                            <p className="card-title">
                              Product Group: {cart.Product_Group}
                            </p>
                            <p className="card-text">
                              Product Name: {cart.Product_Name}
                            </p>
                          </div>
                        ) : cart.type === "packages" ? (
                          <div>
                            <p>Type : Packages</p>
                            <p className="card-title">{cart.name}</p>
                            <p className="card-text">
                              {ReactHtmlParser(cart.description.slice(0, 50))}
                              {"..."}
                            </p>
                          </div>
                        ) : (
                          <p></p>
                        )}
                      </div>
                      <div
                        className="d-flex flex-column align-items-end"
                        style={{ width: "20%" }}
                      >
                        <div className="">
                          <i
                            style={{ cursor: "pointer" }}
                            class="fa-regular fa-rectangle-xmark fs-4"
                            onClick={() => removeItemFromCart(cart.id)}
                          ></i>
                        </div>
                        <div className="d-flex justify-content-around align-items-center w-100">
                          {cart.type === "medicine" ? (
                            <div className="d-flex justify-content-between align-items-center w-50">
                              <div className="w-25">
                                <i
                                  style={{ fontSize: "40px" }}
                                  className="fa-regular fa-square-plus"
                                ></i>
                              </div>
                              <div className="w-25">
                                <input
                                  className="form-control"
                                  id="exampleInputEmail1"
                                  aria-describedby="emailHelp"
                                />
                              </div>
                              <div className="w-25">
                                <i
                                  style={{ fontSize: "40px" }}
                                  className="fa-regular fa-square-minus"
                                ></i>
                              </div>
                              <div className="w-50 text-end">
                                Price: BDT 350
                              </div>
                            </div>
                          ) : cart.type === "investigation" ? (
                            ""
                          ) : cart.type === "packages" ? (
                            <div className="w-50 text-end">
                              Price: {cart.opd_amount}
                            </div>
                          ) : (
                            ""
                          )}
                          {/* <div className="w-50 text-end">
                                    Price: {cart.opd_amount}
                                  </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <h1 style={{ color: "#187979" }} className="text-center">
                No data in cart
              </h1>
            )
          ) : (
            ""
          )}
        </div>
        {cartData ? (
          cartData.length > 0 ? (
            <div>
              <div className="d-flex justify-content-between mt-5">
                <h3>Total Amount:</h3>
                <h3>BDT {totalAmount}</h3>
              </div>
              <div className="d-flex justify-content-center mt-5">
                <button
                  // disabled={cartData.length > 0 ? false : true}
                  type="button"
                  style={{ backgroundColor: "#187979" }}
                  className="btn  btn-sm rounded rounded-lg invBtn w-100"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#bookTestOffcanvasRight"
                  aria-controls="bookTestOffcanvasRight"
                >
                  <a>Book Now</a>
                </button>
              </div>
            </div>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default CartPopUp;



// WEBPACK FOOTER //
// ./src/component/frontend/CartPopUp.js